module.exports = __webpack_public_path__ + "img/unionpay.7d585d0.png";